import { render, staticRenderFns } from "./rz.vue?vue&type=template&id=816f80f4&"
import script from "./rz.vue?vue&type=script&lang=js&"
export * from "./rz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports